<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="状态" prop="pricingType">
        <a-radio-group button-style="solid" v-model="form.pricingType">
          <a-radio-button :value="1"> 自定义 </a-radio-button>
          <a-radio-button :value="0"> 固定 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="固定价格" v-show="form.pricingType == 0" prop="price">
        <a-input v-model="form.price" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>

      <a-form-model-item label="自定义价格" prop="priceMin" v-show="form.pricingType == 1">
        <p>最低价</p>
        <a-input
          v-model="form.priceMin"
          placeholder="请输入"
          :maxLength="50"
          @blur="$refs.form.validateField('priceMin')"
        />
      </a-form-model-item>

      <a-form-model-item prop="priceMax" v-show="form.pricingType == 1">
        <p>最高价</p>
        <a-input
          v-model="form.priceMax"
          placeholder="请输入"
          :maxLength="50"
          @blur="$refs.form.validateField('priceMax')"
        />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group button-style="solid" v-model="form.status">
          <a-radio-button :value="1"> 启用 </a-radio-button>
          <a-radio-button :value="0"> 禁用 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="材料项标识" prop="materialItemId">
        <a-select v-model="form.materialItemId" placeholder="请选择服务" allow-clear style="width: 100%">
          <a-select-option v-for="s in ProjectList" :key="s.id" :value="s.id">
            {{ s.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- <a-form-model-item label="产品SKU标识" prop="prodSkuId">
        <a-input
          v-model="form.prodSkuId"
          placeholder="请输入"
          :maxLength="20"
          oninput="value=value.replace(/[^\d]/g,'')"
        />
      </a-form-model-item> -->
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'
import { fetchList } from '@/api/maintenance/materialitems/index.js'
import { getObj, addObj, putObj } from '@/api/maintenance/materialPricing/index'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    const validatePriceRange = (rule, value, callback) => {
      if (this.form.pricingType !== 1) return callback()
      const { priceMin, priceMax } = this.form
      if (priceMin == null || priceMax == null) {
        return callback(new Error('请填写完整价格区间'))
      }
      if (Number(priceMin) >= Number(priceMax)) {
        return callback(new Error('最高价必须大于最低价'))
      }
      callback()
    }
    return {
      ProjectList: [],
      submitLoading: false,
      data: [],
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        price: undefined,
        priceMin: 0,
        priceMax: 0,
        prodSkuId: undefined,
        materialItemId: undefined,
        sort: 99,
        status: 1,
        pricingType: 0,
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      rules: {
        priceMin: [
          {
            validator: (rule, value, callback) => {
              if (this.form.pricingType !== 1) return callback() // 仅在自定义模式下校验
              if (value === '' || value == null) return callback(new Error('请输入最低价'))
              if (!/^\d+(\.\d{1,2})?$/.test(value)) return callback(new Error('最低价须为数字，最多两位小数'))
              if (Number(value) < 0) return callback(new Error('最低价不能小于 0'))
              if (Number(value) >= Number(this.form.priceMax)) {
                return callback(new Error('最低价必须小于最高价'))
              }
              callback()
            },
            trigger: ['blur', 'change'],
          },
        ],
        priceMax: [
          {
            validator: (rule, value, callback) => {
              if (this.form.pricingType !== 1) return callback()
              if (value === '' || value == null) return callback(new Error('请输入最高价'))
              if (!/^\d+(\.\d{1,2})?$/.test(value)) return callback(new Error('最高价须为数字，最多两位小数'))
              if (Number(value) <= Number(this.form.priceMin)) {
                return callback(new Error('最高价必须大于最低价'))
              }
              callback()
            },
            trigger: ['blur', 'change'],
          },
        ],
        pricingType: [{ required: true, message: '请选择定价方式', trigger: 'change' }],
        price: [
          { required: true, message: '请输入固定价格', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '最多两位小数', trigger: 'blur' },
        ],
        priceRange: [{ validator: validatePriceRange, trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        materialItemId: [
          { required: true, message: '请输入材料项标识', trigger: 'blur' },
          { max: 50, message: '最多50个字符', trigger: 'blur' },
        ],
        prodSkuId: [
          { required: true, message: '请输入产品SKU标识', trigger: 'blur' },
          { pattern: /^\d+$/, message: '只能输入数字', trigger: 'blur' },
          { max: 20, message: '最多20个字符', trigger: 'blur' },
        ],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    getList() {
      fetchList(this.queryParam).then((response) => {
        this.ProjectList = response.data.records
      })
    },
    onClose() {
      this.open = false
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      Object.assign(this.form, {
        id: undefined,
        price: undefined,
        priceMin: 0,
        priceMax: 0,
        prodSkuId: undefined,
        materialItemId: undefined,
        sort: 99,
        status: 1,
        pricingType: 0,
      })
    },
    /** 新增按钮操作 */
    handleAdd(e) {
      this.reset()
      this.getList()
      this.open = true
      this.formTitle = '添加材料定价'
      this.form.prodSkuId = e
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.getList()
      const postId = {
        prodSkuId: row.prodSkuId,
        materialItemId: row.materialItemId,
      }
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改材料定价'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      const that = this
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (that.formTitle === '修改材料定价') {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
